import props from '../../../../redux/props'
import { useSelector } from 'react-redux'

const Footer = () => {
  const t = useSelector((s) => s[props.TRANSLATION])

  return (
    <div className={`flex justify-center gap-x-3 w-full py-3`}>
      {t.footer.legalLinks.map((link: { name: string; link: string }, i: number) => (
        <a href={link.link} className="text-xs font-thin text-white hover:underline" key={i} target="_blank" rel="noreferrer">
          {link.name}
        </a>
      ))}
    </div>
  )
}

export default Footer
